{
  "confluence.lovability.survey.question": [
    {
      "type": 0,
      "value": "How do you feel about Confluence?"
    }
  ],
  "confluence.lovability.survey.statement": [
    {
      "type": 0,
      "value": "We want to hear from you! Please take a moment to share your thoughts."
    }
  ]
}